var map = {
	"./avisos/avisos.module": [
		"./src/app/avisos/avisos.module.ts",
		"avisos-avisos-module~convocatoria-convocatoria-module",
		"avisos-avisos-module"
	],
	"./convocatoria/convocatoria.module": [
		"./src/app/convocatoria/convocatoria.module.ts",
		"avisos-avisos-module~convocatoria-convocatoria-module",
		"convocatoria-convocatoria-module"
	],
	"./evento/evento.module": [
		"./src/app/evento/evento.module.ts",
		"evento-evento-module"
	],
	"./formulario/formulario.module": [
		"./src/app/formulario/formulario.module.ts",
		"formulario-formulario-module"
	],
	"./formulario/formulariov.module": [
		"./src/app/vinculacion/formulario/formulariov.module.ts",
		"formulario-formulariov-module"
	],
	"./pages/pages.module": [
		"./src/app/pages/pages.module.ts",
		"pages-pages-module"
	],
	"./vinculacion/vinculacion.module": [
		"./src/app/vinculacion/vinculacion.module.ts",
		"vinculacion-vinculacion-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error('Cannot find module "' + req + '".');
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var module = __webpack_require__(ids[0]);
		return module;
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;